// У telecom иллюстрации нет: его гостевые страницы — карточка на фоновой
// картинке (brand.layout.auth = 'card', фон — токен --auth-bg-image), а
// иллюстрацию рисует только раскладка 'split'. Файл нужен, чтобы алиас
// @auth-picture-current разрешался в сборке темы.
export const AuthPicture = () => null;
